import React from 'react'
import useSWR from 'swr'
import { Alert, Box, Button, TextField } from '@mui/material'
import api from 'utils/api'

export function useAdmission(type, enabled = true) {
  const { data, error, mutate } = useSWR(enabled ? '/auth/admission' : null, api.get, { shouldRetryOnError: false })
  const status = data?.find(item => item.accountType === type)
  return { status, error, reload: mutate, blocked: enabled && (Boolean(error) || !['OPEN', 'INVITE'].includes(status?.mode)) }
}

export default function InviteField({ admission, value, onChange, onValidate, onClear, validating, resolved, error }) {
  const { status, error: statusError, reload } = admission
  if (statusError) return <Alert severity="error" action={<Button onClick={() => reload()}>Retry</Button>}>Registration availability could not be loaded.</Alert>
  if (!status) return <Alert severity="info">Checking registration availability…</Alert>
  if (status.mode === 'PAUSED') return <Alert severity="info">Registration for this account type is paused.</Alert>
  if (status.mode === 'INVITE' && !status.available) return <Alert severity="info">Registration places for this account type are currently unavailable.</Alert>
  if (resolved) return <Alert severity="success" sx={{ my: 2 }} action={<Button onClick={onClear}>Change</Button>}>
    Invitation applied{resolved.code ? `: ${resolved.code}` : `: ${resolved.label}`}. Choose an account type to continue.
  </Alert>
  if (status.mode !== 'INVITE' && !error) return null
  return <Box my={2}>
    <TextField label="Invite code" value={value} onChange={e => onChange(e.target.value)}
      autoComplete="off" inputProps={{ maxLength: 64 }} required={status.mode === 'INVITE'} fullWidth
      error={Boolean(error)} helperText={error || 'Enter an invite code, then validate it.'} />
    <Button sx={{ mt: 1 }} disabled={validating || !value.trim()} onClick={onValidate}>
      {validating ? 'Checking…' : 'Validate code'}
    </Button>
  </Box>
}
